<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import PickupsComponent from './component.pickups.svelte'
    import PickupComponent from './component.pickup.svelte'
    import PickupUpdateComponent from './component.update.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Recolecciones" subtitle="Consulta y gestión de recolecciones" />
        <PickupsComponent />
    </div>
</View>

<ModalContainer id="pickup_modal" title="Recolección" >
    <PickupComponent />
</ModalContainer>

<ModalContainer id="pickup_update_modal" title="Recolección" >
    <PickupUpdateComponent />
</ModalContainer>